import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import AnimationEffects from "%/dynamic-components/render-engine/options/animation-effects";

export default class AnimationEffectsOptions extends BaseOptionsBundle {
  optionTitle = "Animation Effects";
  static optionClassName = "i-dynamic-animation-effects";

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new AnimationEffects(undefined, hideFromInspector["animation-effects"] ?? false),
    ]);
  }
}
